import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import AccountingContainer from "@/screens/CompanySettings/Accounting/containers/AccountingContainer"
import { accountingSearchParamsSchema } from "@/screens/CompanySettings/Accounting/types/searchParams"

export const Route: AnyRoute = createFileRoute("/app/companies/$companyId/edit/_layout/accounting")({
  validateSearch: zodValidator(accountingSearchParamsSchema),
  component: AccountingContainer,
})
